import { UserCheck, CheckCircle, Clock, CreditCard } from "lucide-react";

const ClientStatsCards = ({ clients }) => {
  const totalClients = clients.length;
  const activeClients = clients.filter(
    (c) => c.status?.toLowerCase() === "active"
  ).length;
  const pendingClients = clients.filter(
    (c) => c.status?.toLowerCase() === "pending"
  ).length;
  const verifiedClients = clients.filter(
    (c) => c.documentType && c.documentType !== "N/A"
  ).length;

  return (
    <div className="grid grid-cols-1 gap-3 xs:grid-cols-2 lg:grid-cols-4 sm:gap-4 lg:gap-6">
      <div className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm transition-shadow duration-300 sm:rounded-xl sm:p-5 lg:p-6 hover:shadow-md">
        <div className="flex justify-between items-center">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-600 truncate sm:text-sm">
              Total Clients
            </p>
            <p className="mt-1 text-xl font-bold text-gray-900 sm:text-2xl lg:text-3xl">
              {totalClients}
            </p>
          </div>
          <div className="flex-shrink-0 p-2 ml-3 bg-blue-100 rounded-lg sm:p-3">
            <UserCheck className="w-4 h-4 text-blue-600 sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
          </div>
        </div>
      </div>

      <div className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm transition-shadow duration-300 sm:rounded-xl sm:p-5 lg:p-6 hover:shadow-md">
        <div className="flex justify-between items-center">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-600 truncate sm:text-sm">
              Active
            </p>
            <p className="mt-1 text-xl font-bold text-green-600 sm:text-2xl lg:text-3xl">
              {activeClients}
            </p>
            <p className="mt-1 text-xs text-gray-500 sm:text-sm">
              {totalClients > 0
                ? Math.round((activeClients / totalClients) * 100)
                : 0}
              % of total
            </p>
          </div>
          <div className="flex-shrink-0 p-2 ml-3 bg-green-100 rounded-lg sm:p-3">
            <CheckCircle className="w-4 h-4 text-green-600 sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
          </div>
        </div>
      </div>

      <div className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm transition-shadow duration-300 sm:rounded-xl sm:p-5 lg:p-6 hover:shadow-md">
        <div className="flex justify-between items-center">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-600 truncate sm:text-sm">
              Pending
            </p>
            <p className="mt-1 text-xl font-bold text-yellow-600 sm:text-2xl lg:text-3xl">
              {pendingClients}
            </p>
            <p className="mt-1 text-xs text-gray-500 sm:text-sm">
              {totalClients > 0
                ? Math.round((pendingClients / totalClients) * 100)
                : 0}
              % of total
            </p>
          </div>
          <div className="flex-shrink-0 p-2 ml-3 bg-yellow-100 rounded-lg sm:p-3">
            <Clock className="w-4 h-4 text-yellow-600 sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
          </div>
        </div>
      </div>

      <div className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm transition-shadow duration-300 sm:rounded-xl sm:p-5 lg:p-6 hover:shadow-md">
        <div className="flex justify-between items-center">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-gray-600 truncate sm:text-sm">
              Verified IDs
            </p>
            <p className="mt-1 text-xl font-bold text-purple-600 sm:text-2xl lg:text-3xl">
              {verifiedClients}
            </p>
            <p className="mt-1 text-xs text-gray-500 sm:text-sm">
              With documents
            </p>
          </div>
          <div className="flex-shrink-0 p-2 ml-3 bg-purple-100 rounded-lg sm:p-3">
            <CreditCard className="w-4 h-4 text-purple-600 sm:w-5 sm:h-5 lg:w-6 lg:h-6" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientStatsCards;
